import { Link } from "react-router-dom";

const facts = [
  { label: "入行年份", value: "1998" },
  { label: "代表作", value: "喜剧之王 · 忘不了" },
  { label: "最新作品", value: "南方来信（待映）" },
  { label: "常驻节目", value: "一屋三餐" },
];

export default function HomeIntroStrip() {
  return (
    <section aria-label="人物速览" className="w-full border-b border-background-200 bg-background-50">
      <div className="flex w-full flex-col gap-6 px-4 py-6 md:flex-row md:items-center md:justify-between md:px-8 md:py-7 lg:px-12">
        <div className="flex items-start gap-4">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
            <i className="ri-user-star-line text-lg" aria-hidden="true"></i>
          </span>
          <div>
            <p className="text-sm font-medium text-foreground-950">人物速览</p>
            <p className="mt-1 max-w-2xl text-xs leading-6 text-foreground-600">
              演员。从《喜剧之王》的海边到即将上映的《南方来信》，她的作品始终围绕普通人的困境与和解展开。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-x-6 gap-y-3 sm:grid-cols-4 md:shrink-0 md:gap-x-8">
          {facts.map((fact) => (
            <div key={fact.label}>
              <p className="text-[10px] uppercase tracking-[0.18em] text-foreground-400">{fact.label}</p>
              <p className="mt-1 text-xs text-foreground-900">{fact.value}</p>
            </div>
          ))}
        </div>

        <Link
          to="/about"
          className="inline-flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap text-xs text-primary-700 transition-colors hover:text-primary-800"
        >
          了解本站
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>
    </section>
  );
}